

function allPropsHaveValue(props) {
    if (typeof props !== 'object')
        return false;

    Object.entries(props).forEach(x => {
        if (x === undefined || x === null)
            return false;
    });

    return true;
}

export { allPropsHaveValue };